module.exports = __webpack_public_path__ + "media/images/digital_sign-f6659afb4ebf0055afdd810368b2092e.png";